import apiClient from './index'
import type { Product, ProductCreate, ProductUpdate } from '@/types'
import type { ListQueryParams } from './types'

const BASE_URL = '/ssp/products'

export const productsApi = {
  getAll: (params?: ListQueryParams) => apiClient.get<Product[]>(BASE_URL, { params })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to fetch products:', error)
      throw error
    }),
  getById: (id: number) => apiClient.get<Product>(`${BASE_URL}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to fetch product:', error)
      throw error
    }),
  create: (data: ProductCreate) => apiClient.post<Product>(BASE_URL, data)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to create product:', error)
      throw error
    }),
  update: (id: number, data: ProductUpdate) => apiClient.put<Product>(`${BASE_URL}/${id}`, data)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to update product:', error)
      throw error
    }),
  delete: (id: number) => apiClient.delete<Product>(`${BASE_URL}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to delete product:', error)
      throw error
    }),
  exportExcel: () => apiClient.get(`${BASE_URL}/export`, { responseType: 'blob' })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to export products to Excel:', error)
      throw error
    }),
  importExcel: (file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.post<{ created: number, updated: number, errors: number, error_details?: { row: number, error: string }[] }>(`${BASE_URL}/import`, formData)
      .then(res => res.data)
      .catch(error => {
        console.error('Failed to import products from Excel:', error)
        throw error
      })
  }
}
